import bwSTL from "../assets/icons/bw-stl-icon.svg";
import coloredSTL from "../assets/icons/colored-stl-icon.svg";
import { useState } from "react";
import { uploadToStorage, downloadFromStorage } from "../js/firebase/storage";
import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { createRef } from "react";
import { functions } from "../firebase";

function FileUploadComponent() {
  const [srcIcon, setSrcIcon] = useState(bwSTL);
  const { setFile, setNotification, setLoader } = useContext(AppContext);
  const inputFileRef = createRef();

  const onErr = (err) => {
    setNotification({ message: err, style: "alert" });
    setFile(undefined);
    setLoader(false);
  };
  const importFile = (file) => {
    let url = URL.createObjectURL(file);
    if (file.name.endsWith(".stl") || file.name.endsWith(".STL")) {
      setLoader(true);
      let bufferReader = new FileReader();
      bufferReader.readAsArrayBuffer(file);
      bufferReader.addEventListener(
        "load",
        () => {
          // Create the file metadata
          let metadata = {
            contentType: "stl",
            contentDisposition: `attachment;filename=${file.name}`,
          };
          let timestamp = new Date(Date.now()).toLocaleString("sv-SE");
          let format = "stl";
          let fileID =
            timestamp.replace(" ", "").replaceAll("-", "").replaceAll(":", "") +
            Math.random().toString(36).slice(2);
          let fileName = file.name.split(".")[0];
          // Upload file and metadata to the storage
          uploadToStorage(
            `objects/${fileID}`,
            `${fileID}.${format}`,
            bufferReader.result,
            metadata
          )
            .then(() => {
              let generateSupports = functions.httpsCallable(
                "generateSupports",
                { timeout: 540 * 1000 }
              );
              return new Promise((resolve, reject) => {
                generateSupports({
                  part_id: fileID,
                  options: ["orientations", "support_areas"],
                  settings: { overhang_angle: 55 },
                }).then((response) => {
                  if (response.data.statusCode === 200) {
                    downloadFromStorage(
                      `objects/${fileID}/${fileID}_orientation1_support_areas.glb`
                    )
                      .then((url) => {
                        setFile({
                          id: fileID,
                          originalName: fileName,
                          currentView: "partView",
                          models: {
                            ...file.models,
                            partView: {
                              name: fileName + "_orientation1_support_areas",
                              format: "glb",
                              url: url,
                            },
                          },
                        });
                      })
                      .catch((err) => {
                        onErr(err);
                      });
                  } else {
                    onErr(response.data.statusCode);
                  }
                });
              });
            })
            .catch((err) => {
              onErr(err);
            });
        },
        false
      );
    } else {
      //on load wrong extension
      //on drop wrong extension
      onErr("Wrong file type");
    }
  };

  const handleDrop = (e) => {
    //prevent the default behavior of the browser when something is dropped
    e.preventDefault();
    //stop the event from being propagated through parent and child elements
    e.stopPropagation();
    if (e.dataTransfer.files.length !== 0) {
      importFile(e.dataTransfer.files[0]);
      var element = document.querySelector(".file-upload-panel");
      element.classList.remove("ondrag");
      setSrcIcon(bwSTL);
    }
  };

  const handleDragOver = (e) => {
    //prevent the default behavior of the browser when something is dragged in
    e.preventDefault();
    //stop the event from being propagated through parent and child elements
    e.stopPropagation();
    var element = document.querySelector(".file-upload-panel");
    element.classList.add("ondrag");
    setSrcIcon(coloredSTL);
  };
  const handleDragLeave = (e) => {
    //prevent the default behavior of the browser when something is dropped
    e.preventDefault();
    //stop the event from being propagated through parent and child elements
    e.stopPropagation();
    var element = document.querySelector(".file-upload-panel");
    element.classList.remove("ondrag");
    setSrcIcon(bwSTL);
  };
  return (
    <div className="upload-container">
      <div
        className="file-upload-panel"
        onDrop={(e) => handleDrop(e)}
        onDragOver={(e) => handleDragOver(e)}
        onDragLeave={(e) => handleDragLeave(e)}
      >
        <span id="icon"></span>
        <img src={srcIcon} alt="import stl"></img>
        <div className="panel-label">
          <h4>Drag & Drop</h4>
        </div>
        <div className="panel-label">
          <b>OR</b>
        </div>
        <input
          type="file"
          id="file-upload"
          accept=".stl, .STL"
          hidden
          ref={inputFileRef}
          onChange={(e) => {
            let file = e.target.files[0];
            importFile(file);
          }}
          onClick={(event) => {
            event.target.value = "";
          }}
        />
        <button
          className=" primary-button"
          onClick={() => {
            inputFileRef.current.click();
          }}
        >
          Browse files
        </button>
      </div>
    </div>
  );
}

export default FileUploadComponent;
